import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { HelpSectionNavigation } from "./help/-components/HelpSectionNavigation";

export const Route = createFileRoute("/_auth/app/_app/help")({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();

	// Determine active section based on current route
	const getActiveSection = () => {
		const pathname = location.pathname;
		if (pathname === "/app/help" || pathname === "/app/help/") {
			return "gettingStarted";
		}
		if (pathname.includes("/user-guide")) return "userGuide";
		if (pathname.includes("/faq")) return "faq";
		if (pathname.includes("/tutorials")) return "tutorials";
		if (pathname.includes("/support")) return "support";
		return "gettingStarted"; // default
	};

	const activeSection = getActiveSection();

	return (
		<div
			className={`flex flex-col md:flex-row h-full ${activeSection === "gettingStarted" ? "bg-base-100" : "bg-base-200"}`}
			data-testid="help-page-container"
		>
			{/* Side Navigation - hidden on mobile */}
			<div
				className={
					activeSection === "gettingStarted" ? "hidden" : "hidden md:block"
				}
			>
				<HelpSectionNavigation activeSection={activeSection} />
			</div>

			{/* Main Content Area - always visible */}
			<div
				className="min-w-0 flex-1 overflow-auto"
				data-testid="help-main-content-area"
			>
				<Outlet />
			</div>
		</div>
	);
}
